import { render, staticRenderFns } from "./MobileMenuTab.vue?vue&type=template&id=09775c30&scoped=true&"
import script from "./MobileMenuTab.vue?vue&type=script&lang=js&"
export * from "./MobileMenuTab.vue?vue&type=script&lang=js&"
import style0 from "./MobileMenuTab.vue?vue&type=style&index=0&id=09775c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09775c30",
  null
  
)

export default component.exports